<script setup lang="ts">
// A rounded card of rows in a phone bottom sheet, with hairlines between the rows.
</script>

<template>
  <div
    class="mx-4 overflow-hidden rounded-2xl bg-white dark:bg-dark-800 shadow-[0_1px_2px_rgba(0,0,0,0.04)] [&>*+*]:border-t [&>*+*]:border-solid [&>*+*]:border-gray-100 dark:[&>*+*]:border-dark-700"
  >
    <slot />
  </div>
</template>
